module.exports = __webpack_public_path__ + "img/logo_京东.4b7cb33d.png";